var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFieldAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136,
    height: 95,
    viewBox: "0 0 136 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_28",
    x: 0,
    y: 0,
    width: 136,
    height: 95,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M0,0H22.165V55H0Z",
    transform: "translate(0 -3)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57",
    "data-name": "Grupo 57",
    transform: "translate(-396 -344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_52",
    "data-name": "Grupo 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    transform: "translate(270 119.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23",
    transform: "translate(-160 129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(-406 -300.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 692, 396)",
    filter: "url(#Trazado_28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_28-2",
    "data-name": "Trazado 28",
    transform: "translate(9 9)",
    fill: "rgba(232,70,113,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 111 76.5 L 7 76.5 C 3.415892362594604 76.5 0.5 73.5841064453125 0.5 70 L 0.5 7 C 0.5 3.415892362594604 3.415892362594604 0.5 7 0.5 L 111 0.5 C 114.5841064453125 0.5 117.5 3.415892362594604 117.5 7 L 117.5 70 C 117.5 73.5841064453125 114.5841064453125 76.5 111 76.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7 1 C 3.691581726074219 1 1 3.691581726074219 1 7 L 1 70 C 1 73.30841827392578 3.691581726074219 76 7 76 L 111 76 C 114.3084182739258 76 117 73.30841827392578 117 70 L 117 7 C 117 3.691581726074219 114.3084182739258 1 111 1 L 7 1 M 7 0 L 111 0 C 114.8659973144531 0 118 3.134002685546875 118 7 L 118 70 C 118 73.86599731445312 114.8659973144531 77 111 77 L 7 77 C 3.134002685546875 77 0 73.86599731445312 0 70 L 0 7 C 0 3.134002685546875 3.134002685546875 0 7 0 Z",
    stroke: "none",
    fill: "#314164"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_34",
    "data-name": "L\\xEDnea 34",
    y2: 75.75,
    transform: "translate(760.5 405.5)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_19",
    "data-name": "Elipse 19",
    transform: "translate(750 433)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29",
    transform: "translate(230.835 248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_1",
    "data-name": "Enmascarar grupo 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M19.671,0C8.627,1.233,0,11.731,0,24.5A27.538,27.538,0,0,0,2.014,34.838C5.039,42.437,11.73,48.113,19.671,49Z",
    transform: "translate(2.494)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(157.165 297) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_1-2",
    "data-name": "Enmascarar grupo 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25-2",
    "data-name": "Trazado 25",
    d: "M19.671,0C8.627,1.233,0,11.731,0,24.5A27.538,27.538,0,0,0,2.014,34.838C5.039,42.437,11.73,48.113,19.671,49Z",
    transform: "translate(2.494)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldAvailable);
export default __webpack_public_path__ + "static/media/field-available.8d36b7412e180276f1110cada1906c7c.svg";
export { ForwardRef as ReactComponent };